module.exports = __webpack_public_path__ + "img/pic15.b5b6e231.png";